import React from "react";
import { Typography } from "@mui/material";

/**
 * Section heading rendered ABOVE a results DataGrid.
 *
 * This used to be a factory producing a component for DataGrid's `Toolbar`
 * slot, but that placed an `<h6>` inside the `role="grid"` element — invalid
 * ARIA structure (axe aria-required-children, WCAG 1.3.1/4.1.2): a grid may
 * only contain rows/rowgroups. Rendering the heading as a sibling above the
 * grid keeps the visual layout and makes it a real, AT-navigable heading.
 */
export const GridSectionHeader = ({
  title,
  color = "#1c1c1c",
  icon,
}: {
  title: string;
  color?: string;
  icon?: JSX.Element;
}) => (
  <Typography
    variant="subtitle1"
    sx={{
      pl: 1,
      pt: 0.5,
      pb: 0.5,
      backgroundColor: color,
    }}
  >
    {title} {icon}
  </Typography>
);
